<template>
  <div id="app">
    <HomeHeader v-if="this.$route.meta.topShow"></HomeHeader>
    <router-view></router-view>
    <HomeFooter v-if="this.$route.meta.bottomShow"></HomeFooter>
    <FloatBar v-if="this.$route.meta.wxbar"></FloatBar>
    <CookieView v-if="cookieVisible"></CookieView>
  </div>
</template>

<script>
import HomeHeader from './components/HomeHeader';
import HomeFooter from './components/HomeFooter';
import FloatBar from './components/FloatBar';
import CookieView from './components/CookieView';
import Products from './pages/Products';
import { listProductsType } from './api';
import { readData, delData } from './utils/myutils';
export default {
  name: 'App',
  data() {
    return {
      cookieVisible: false
    }
  },
  components: {
    Products
  },
  mounted() {
    this.getTypesData();
    // delData('cookieConsent');
    this.cookieVisible = readData('cookieConsent') == null;
    // 路由感知的翻译控制
    this.$nextTick(() => {
      this.handleRouteTranslate(this.$route.path);
    });
  },
  metaInfo() {
    return {
      title: this.$route.meta.metaInfo.title,
      meta: [
        { name: "keywords", content: this.$route.meta.metaInfo.keywords },
        { name: "description", content: this.$route.meta.metaInfo.description },
      ]
    }
  },
  methods: {

    // 路由感知的翻译控制
    handleRouteTranslate(path) {
      if (!window.translate) return;
      if (path.startsWith('/admin')) {
        // 管理端：还原原文
        window.translate.reset();
        window.translate.language.translateLocal = false;
      } else {
        // 非管理端：重新执行翻译
        window.translate.language.translateLocal = true;
        window.translate.execute();
      }
    },

    async getTypesData() {
      let data = await listProductsType();
      if (data.code == 200) {
        this.$store.dispatch('setTypeData', data.data);
      } else {
        this.$message.error(data.message);
      }
    }
  },
  components: {
    HomeHeader,
    HomeFooter,
    FloatBar,
    CookieView
  },
  watch: {
    '$route.path': {
      handler(path) {
        this.handleRouteTranslate(path);
      }
    }
  }
}
</script>

<style>
#app {
  background: #FFF;
}
</style>
